<template>
  <svg class="aoform__close" :class="{'aoform__close_left': toLeft}" role="button" aria-label="close" :tabindex="$store.state.loading?-1:0" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
    <path d="M25 1L1 25" :stroke="color" stroke-width="2" stroke-linecap="round"></path>
    <path d="M25 25L1 1" :stroke="color" stroke-width="2" stroke-linecap="round"></path>
  </svg>
</template>

<script>
export default {
  props: {
    color: {type: String, default: 'black'},
    toLeft: {type: Boolean, default: false}
  }
}
</script>

<style lang="sass">
.aoform__close
  &:not(:focus-visible)
    outline: none
  display: block
  width: var(--closebtn-height)
  padding: 10px
  margin: -10px calc(var(--formpadding) - 10px)
  cursor: pointer
  position: relative
  z-index: 1
  &:nth-child(n)
    box-sizing: content-box
  &_left
    margin-left: auto
  @include from(breakpoints.$formMob)
    margin-left: auto
</style>